// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import '../styling/global.css';
// import BackgroundEffect from '../components/BackgroundEffect';
// import tick from '../assets/tick.png';

// const Careers = () => {
//     const [formData, setFormData] = useState({
//         fullName: '',
//         email: '',
//         phone: '',
//         position: '',
//         resume: null,
//         linkedin: '',
//         portfolio: '',
//         message: '',
//         agree: false,
//     });

//     const [errors, setErrors] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [captcha, setCaptcha] = useState('');
//     const [captchaInput, setCaptchaInput] = useState('');
//     const [captchaError, setCaptchaError] = useState(false);
//     const [loading, setLoading] = useState(false);


//     const generateCaptcha = () => {
//         const newCaptcha = Math.random().toString(36).substring(2, 8).toUpperCase();
//         setCaptcha(newCaptcha);

//         const canvas = document.getElementById('captchaCanvas');
//         const ctx = canvas.getContext('2d');

//         // Clear canvas
//         ctx.clearRect(0, 0, canvas.width, canvas.height);

//         // Add background noise
//         ctx.fillStyle = "#f2f2f2";
//         ctx.fillRect(0, 0, canvas.width, canvas.height);

//         for (let i = 0; i < 5; i++) {
//             ctx.strokeStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.4)`;
//             ctx.beginPath();
//             ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
//             ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
//             ctx.stroke();
//         }

//         // Draw the CAPTCHA text
//         ctx.font = '26px Arial';
//         ctx.fillStyle = '#000';
//         for (let i = 0; i < newCaptcha.length; i++) {
//             const x = 20 + i * 20;
//             const y = 30 + Math.random() * 10;
//             const rotation = (Math.random() - 0.5) * 0.4;

//             ctx.save();
//             ctx.translate(x, y);
//             ctx.rotate(rotation);
//             ctx.fillText(newCaptcha[i], 0, 0);
//             ctx.restore();
//         }
//     };


//     useEffect(() => {
//         generateCaptcha();
//     }, []);


//     const handleChange = (e) => {
//         const { name, value, type, checked, files } = e.target;
//         const maxSize = 5 * 1024 * 1024; 

//         if (type === 'file') {
//             const file = files[0];
//             if (file && file.size > maxSize) {
//                 setErrors(prev => ({
//                     ...prev,
//                     [name]: 'File size must be less than 5MB',
//                 }));
//                 setFormData(prev => ({ ...prev, [name]: null }));
//             } else {
//                 setErrors(prev => ({
//                     ...prev,
//                     [name]: undefined,
//                 }));
//                 setFormData(prev => ({ ...prev, [name]: file }));
//             }
//         } else if (type === 'checkbox') {
//             setFormData(prev => ({ ...prev, [name]: checked }));
//         } else {
//             setFormData(prev => ({ ...prev, [name]: value }));
//         }
//     };


//     const validate = () => {
//         const newErrors = {};
//         if (!formData.fullName) newErrors.fullName = 'Full Name is required';
//         if (!formData.email) newErrors.email = 'Email is required';
//         if (!formData.phone) newErrors.phone = 'Phone Number is required';
//         if (!formData.position) newErrors.position = 'Position is required';
//         if (!formData.resume) newErrors.resume = 'Resume is required';
//         if (!formData.agree) newErrors.agree = 'You must agree to the privacy policy';
//         return newErrors;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const validationErrors = validate();
//         setErrors(validationErrors);

//         if (Object.keys(validationErrors).length === 0) {
//             if (captchaInput.toUpperCase() !== captcha) {
//                 setCaptchaError(true);
//                 return;
//             } else {
//                 setCaptchaError(false);
//             }

//             try {
//                 setLoading(true); // Show loading indicator
//                 const data = new FormData();
//                 Object.keys(formData).forEach((key) => {
//                     data.append(key, formData[key]);
//                 });

//                 await axios.post('http://localhost:5000/api/submit', data);
//                 setSubmitted(true);
//             } catch (error) {
//                 console.error('Error submitting form:', error);
//             } finally {
//                 setLoading(false); // Hide loading indicator
//             }
//         }
//     };

//     return (
//         <div className="careers-container">
//             <BackgroundEffect />
//             {!submitted ? (
//                 <form className="careers-form" onSubmit={handleSubmit}>
//                     <h2>Apply Now</h2>
//                     <div className="form-row">
//                         <div className="form-group">
//                             <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} />
//                             {errors.fullName && <div className="form-error">{errors.fullName}</div>}
//                         </div>
//                         <div className="form-group">
//                             <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
//                             {errors.email && <div className="form-error">{errors.email}</div>}
//                         </div>
//                     </div>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} />
//                             {errors.phone && <div className="form-error">{errors.phone}</div>}
//                         </div>
//                         <div className="form-group">
//                             <input type="text" name="position" placeholder="Position" value={formData.position} onChange={handleChange} />
//                             {errors.position && <div className="form-error">{errors.position}</div>}
//                         </div>
//                     </div>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>Resume (PDF, DOC, DOCX)</label>
//                             <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} />
//                             {errors.resume && <div className="form-error">{errors.resume}</div>}
//                         </div>
//                     </div>

//                     <div className="form-group">
//                         <input type="text" name="linkedin" placeholder="LinkedIn Profile" value={formData.linkedin} onChange={handleChange} />
//                     </div>

//                     <div className="form-group">
//                         <input type="text" name="portfolio" placeholder="Portfolio" value={formData.portfolio} onChange={handleChange} />
//                     </div>

//                     <div className="form-group">
//                         <textarea name="message" placeholder="Write your message" value={formData.message} onChange={handleChange}></textarea>
//                     </div>

//                     <div className="checkbox-group">
//                         <input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} className="custom-checkbox" />{' '}
//                         I agree to the processing of my personal data according to the Privacy Policy
//                         {errors.agree && <div className="form-error">{errors.agree}</div>}
//                     </div>

//                     <div className="captcha-group-row">
//                         <div className="captcha-box">
//                             <canvas id="captchaCanvas" width="150" height="50"></canvas>
//                             <button type="button" onClick={generateCaptcha} className="refresh-button">⟳</button>
//                         </div>
//                         <input
//                             type="text"
//                             placeholder="Enter CAPTCHA"
//                             value={captchaInput}
//                             onChange={(e) => setCaptchaInput(e.target.value)}
//                             className="captcha-input"
//                             onCopy={(e) => e.preventDefault()}
//                             onCut={(e) => e.preventDefault()}
//                             onPaste={(e) => e.preventDefault()}
//                         />
//                         {captchaError && <div className="form-error">CAPTCHA not verified</div>}
//                     </div>
//                     <button type="submit" className="submit-button" disabled={loading}>
//                         {loading ? (
//                             <span className="loading-content">
//                                 <span className="spinner" /> Submitting...
//                             </span>
//                         ) : (
//                             'SUBMIT APPLICATION'
//                         )}
//                     </button>
//                 </form>
//             ) : (
//                 <div className='success-card'>
//                     <div className="success-message">
//                         <img src={tick} alt="trustee logo" className="tick-image" />
//                         <h2>Application Submitted Successfully!</h2>
//                         <p>
//                             Thank you for applying to our team. We’ll review your application and get back to you soon.<br />
//                             In the meantime, check out our
//                             <a href="/about-us" className="about-link"> About Us </a>
//                             page to learn more about our culture.
//                         </p>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Careers;






// import React, { useState, useEffect } from 'react';
// import '../styling/global.css';
// import BackgroundEffect from '../components/BackgroundEffect';
// import tick from '../assets/tick.png';

// const Careers = () => {
//     const [formData, setFormData] = useState({
//         fullName: '',
//         email: '',
//         phone: '',
//         position: '',
//         resume: null,
//         linkedin: '',
//         portfolio: '',
//         message: '',
//         agree: false,
//     });

//     const [errors, setErrors] = useState({});
//     const [submitted, setSubmitted] = useState(false);
//     const [captcha, setCaptcha] = useState('');
//     const [captchaInput, setCaptchaInput] = useState('');
//     const [captchaError, setCaptchaError] = useState(false);
//     const [loading, setLoading] = useState(false);


//     const generateCaptcha = () => {
//         const newCaptcha = Math.random().toString(36).substring(2, 8).toUpperCase();
//         setCaptcha(newCaptcha);

//         const canvas = document.getElementById('captchaCanvas');
//         const ctx = canvas.getContext('2d');

//         // Clear canvas
//         ctx.clearRect(0, 0, canvas.width, canvas.height);

//         // Add background noise
//         ctx.fillStyle = "#f2f2f2";
//         ctx.fillRect(0, 0, canvas.width, canvas.height);

//         for (let i = 0; i < 5; i++) {
//             ctx.strokeStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.4)`;
//             ctx.beginPath();
//             ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
//             ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
//             ctx.stroke();
//         }

//         // Draw the CAPTCHA text
//         ctx.font = '26px Arial';
//         ctx.fillStyle = '#000';
//         for (let i = 0; i < newCaptcha.length; i++) {
//             const x = 20 + i * 20;
//             const y = 30 + Math.random() * 10;
//             const rotation = (Math.random() - 0.5) * 0.4;

//             ctx.save();
//             ctx.translate(x, y);
//             ctx.rotate(rotation);
//             ctx.fillText(newCaptcha[i], 0, 0);
//             ctx.restore();
//         }
//     };


//     useEffect(() => {
//         generateCaptcha();
//     }, []);


//     const handleChange = (e) => {
//         const { name, value, type, checked, files } = e.target;
//         const maxSize = 5 * 1024 * 1024;

//         if (type === 'file') {
//             const file = files[0];
//             if (file && file.size > maxSize) {
//                 setErrors(prev => ({
//                     ...prev,
//                     [name]: 'File size must be less than 5MB',
//                 }));
//                 setFormData(prev => ({ ...prev, [name]: null }));
//             } else {
//                 setErrors(prev => ({
//                     ...prev,
//                     [name]: undefined,
//                 }));
//                 setFormData(prev => ({ ...prev, [name]: file }));
//             }
//         } else if (type === 'checkbox') {
//             setFormData(prev => ({ ...prev, [name]: checked }));
//         } else {
//             setFormData(prev => ({ ...prev, [name]: value }));
//         }
//     };


//     const validate = () => {
//         const newErrors = {};
//         if (!formData.fullName) newErrors.fullName = 'Full Name is required';
//         if (!formData.email) newErrors.email = 'Email is required';
//         if (!formData.phone) newErrors.phone = 'Phone Number is required';
//         if (!formData.position) newErrors.position = 'Position is required';
//         if (!formData.resume) newErrors.resume = 'Resume is required';
//         if (!formData.agree) newErrors.agree = 'You must agree to the privacy policy';
//         return newErrors;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const validationErrors = validate();
//         setErrors(validationErrors);

//         if (Object.keys(validationErrors).length === 0) {
//             if (captchaInput.toUpperCase() !== captcha) {
//                 setCaptchaError(true);
//                 return;
//             } else {
//                 setCaptchaError(false);
//             }

//             setLoading(true);
//             setTimeout(() => {
//                 setLoading(false);
//                 setSubmitted(true);
//             }, 2000); // simulate delay
//         }
//     };


//     return (
//         <div className="careers-container">
//             <BackgroundEffect />
//             {!submitted ? (
//                 <form className="careers-form" onSubmit={handleSubmit}>
//                     <p
//                         style={{
//                             backgroundColor: '#fff3cd',
//                             color: '#856404',
//                             padding: '10px 16px',
//                             border: '1px solid #ffeeba',
//                             borderRadius: '4px',
//                             marginBottom: '20px',
//                             fontWeight: '500',
//                             fontSize: '18px'
//                         }}
//                     >
//                         Our servers are currently experiencing high traffic. You can still submit your application below or reach us directly at{' '}
//                         <a href="mailto:info@jsktechnologies.in" style={{ color: '#004085', textDecoration: 'underline' }}>
//                             careers@jsktechnologies.in
//                         </a>.
//                     </p>
//                     <h2>Apply Now</h2>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} />
//                             {errors.fullName && <div className="form-error">{errors.fullName}</div>}
//                         </div>
//                         <div className="form-group">
//                             <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} />
//                             {errors.email && <div className="form-error">{errors.email}</div>}
//                         </div>
//                     </div>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} />
//                             {errors.phone && <div className="form-error">{errors.phone}</div>}
//                         </div>
//                         <div className="form-group">
//                             <input type="text" name="position" placeholder="Position" value={formData.position} onChange={handleChange} />
//                             {errors.position && <div className="form-error">{errors.position}</div>}
//                         </div>
//                     </div>

//                     <div className="form-row">
//                         <div className="form-group">
//                             <label>Resume (PDF, DOC, DOCX)</label>
//                             <input type="file" name="resume" accept=".pdf,.doc,.docx" onChange={handleChange} />
//                             {errors.resume && <div className="form-error">{errors.resume}</div>}
//                         </div>
//                     </div>

//                     <div className="form-group">
//                         <input type="text" name="linkedin" placeholder="LinkedIn Profile" value={formData.linkedin} onChange={handleChange} />
//                     </div>

//                     <div className="form-group">
//                         <input type="text" name="portfolio" placeholder="Portfolio" value={formData.portfolio} onChange={handleChange} />
//                     </div>

//                     <div className="form-group">
//                         <textarea name="message" placeholder="Write your message" value={formData.message} onChange={handleChange}></textarea>
//                     </div>

//                     <div className="checkbox-group">
//                         <input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} className="custom-checkbox" />{' '}
//                         I agree to the processing of my personal data according to the Privacy Policy
//                         {errors.agree && <div className="form-error">{errors.agree}</div>}
//                     </div>

//                     <div className="captcha-group-row">
//                         <div className="captcha-box">
//                             <canvas id="captchaCanvas" width="150" height="50"></canvas>
//                             <button type="button" onClick={generateCaptcha} className="refresh-button">⟳</button>
//                         </div>
//                         <input
//                             type="text"
//                             placeholder="Enter CAPTCHA"
//                             value={captchaInput}
//                             onChange={(e) => setCaptchaInput(e.target.value)}
//                             className="captcha-input"
//                             onCopy={(e) => e.preventDefault()}
//                             onCut={(e) => e.preventDefault()}
//                             onPaste={(e) => e.preventDefault()}
//                         />
//                         {captchaError && <div className="form-error">CAPTCHA not verified</div>}
//                     </div>
//                     <button type="submit" className="submit-button" disabled={loading}>
//                         {loading ? (
//                             <span className="loading-content">
//                                 <span className="spinner" /> Submitting...
//                             </span>
//                         ) : (
//                             'SUBMIT APPLICATION'
//                         )}
//                     </button>
//                 </form>
//             ) : (
//                 <div className='success-card'>
//                     <div className="success-message">
//                         <img src={tick} alt="trustee logo" className="tick-image" />
//                         <h2>Application Submitted Successfully!</h2>
//                         <p>
//                             Thank you for applying to our team. We’ll review your application and get back to you soon.<br />
//                             In the meantime, check out our
//                             <a href="/about-us" className="about-link"> About Us </a>
//                             page to learn more about our culture.
//                         </p>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Careers;





import React from 'react';
import '../styling/global.css';
import BackgroundEffect from '../components/BackgroundEffect';

const Careers = () => {
    return (
        <div className="careers-container">
            <BackgroundEffect />
            <form className="careers-form">
                <p style={{
                    fontSize: '22px',
                    color: '#333',
                    lineHeight: '1.6',
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    margin: '20px 0'
                }}>
                    <strong>JSK Technologies</strong> is hiring for <strong>AI Data Analyst</strong> roles on a regular basis.
                    If you're passionate about training AI tools, we'd love to hear from you.
                    Please share your resume with us at{' '}
                    <a
                        href="mailto:careers@jsktechnologies.in"
                        style={{ color: '#004085', textDecoration: 'underline' }}
                    >
                        careers@jsktechnologies.in
                    </a>.
                    <br /><br />
                    If you do not receive a response within 72 hours, please consider that at this time we are not hiring AI Data Analyst.
                    We encourage you to continue applying for other opportunities.
                </p>
            </form>
        </div>
    );
};

export default Careers;
